import { createSelector } from 'reselect';

export const selectReportCategory = createSelector(
  (state) => state.addReportCat,
  (reportCat) => reportCat.reportCatData
);

export default selectReportCategory;
